import Icon from '../components/Icon.vue'

Icon.register({"paragraph":{"width":1280,"height":1792,"paths":[{"d":"M1278 189v73q0 29-18.5 61t-42.5 32q-50 0-54 1-26 6-32 31-3 11-3 64v1152q0 25-18 43t-43 18h-108q-25 0-43-18t-18-43v-1218h-143v1218q0 25-17.5 43t-43.5 18h-108q-26 0-43.5-18t-17.5-43v-496q-147-12-245-59-126-58-192-179-64-117-64-259 0-166 88-286 88-118 209-159 111-37 417-37h479q25 0 43 18t18 43z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/paragraph.js
// module id = 1145
// module chunks = 0